// ================================================= /
// ======   Superlatives JS   ====================== /
// ================================================= /

/* global jQuery */

import helpers from './helpers';
import slider from './slider';

/**
 * Class for controlling the superlatives
 */
class DispatchSkinSuperlatives {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-superlatives';

		this.superlativeSelector = `${this.selector}__superlative`;

		this.activeSuperlatives = 2;
		this.interval = 6500;

		this.superlatives = [];
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		this.superlatives = jQuery( this.selector );

		if ( this.superlatives.length ) {

			this.events();
		}
	}

	/**
	 * Wires up events
	 */
	events() {

		this.eventDelegationParent = jQuery( '.site' );

		slider.addHook(
			'setState',
			this.selector,
			this.handleSlideChange.bind( this )
		);

		slider.addHook(
			'beforeTouch',
			this.selector,
			() => false
		);

		// The interval
		window.setInterval(
			function() {

				const scrollTop = jQuery( window ).scrollTop();

				this.superlatives.each(
					function( index, superlatives ) {

						superlatives = jQuery( superlatives );

						const offset = superlatives.offset();
						offset.bottom = offset.top + superlatives.outerHeight();

						if ( helpers.doElementOffsetsIntersect( offset, { top: scrollTop, bottom: scrollTop + window.innerHeight } ) ) {
							slider.changeSlide( superlatives, slider.getActiveIndex( superlatives ) + 1 );
						}
					}
				);
			}.bind( this ),
			this.interval
		);
	}

	/**
	 * Handles slide change.
	 */
	handleSlideChange( superlatives, toIndex ) {

		superlatives.find( this.superlativeSelector ).eq( toIndex + 1 )
			.addClass( slider.activeClass );
	}

}

const superlatives = new DispatchSkinSuperlatives();
export default superlatives;



// WEBPACK FOOTER //
// ./src/js/inc/superlatives.js